import {assertTrue} from '../../utils/Assert';

class BoxAndWhiskerDataPoint {
    constructor(d) {
        this.name = d.name;
        this.min = d.min;
        this.firstQuartile = d.firstQuartile;
        this.median = d.median;
        this.thirdQuartile = d.thirdQuartile;
        this.max = d.max;
        this.you = d.you;
        this.primaryColor = d.primaryColor;
        this.secondaryColor = d.secondaryColor;

        assertTrue(this.min <= this.firstQuartile);
        assertTrue(this.firstQuartile <= this.median);
        assertTrue(this.median <= this.thirdQuartile);
        assertTrue(this.thirdQuartile <= this.max);
    }
}

export default BoxAndWhiskerDataPoint;
